<template>
<div :class="['meal-detail', { 'screen-lg': onTabletUp }, this.currentView.context]">
  <Hero :imageUrl="meal.imageUrl" :title="meal.name" />

  <div class="detail-content-container">
    <!-- TODO: Fix logic for adding to selected Mealtime Slot - Q1 2020 -->
    <!-- <BaseButton type="button" class="btn-secondary btn-with-icon btn-ghost btn-block" @click="addMeal" v-if="!data.isPlanned">
      <BaseIcon name="plus-circle" />
      Add to Plan
    </BaseButton> -->

    <div class="remove-link" @click="removeMeal" v-if="data.isPlanned">
      {{ $t('recipes.lblRemoveFromPlan') }}
    </div>

    <h4 class="section-title">{{ $t('lblRecipes') }}</h4>
    <div v-for="recipe in meal.recipes">
      <MealCard :dish="recipe" :hideButton="true" @showDishDetails="showDishDetails(recipe)" />
    </div>
  </div>
</div>
</template>

<script>
import store from '@state/store';
import MealCard from '../MealCard/MealCard';
import Hero from '../Hero/Hero';
import {
  kitchenDrawerComputed,
  kitchenDrawerMethods,
  mealsComputed,
  mealsMethods,
  recipesComputed,
  recipesMethods,
  dishesMethods,
  planMethods,
  primaryNavComputed,
  primaryNavMethods,
  groceryListMethods,
} from '@state/helpers';

export default {
  components: {
    Hero,
    MealCard,
  },
  props: {
    isEmbed: {
      type: Boolean,
    },
    data: {
      type: Object,
      required: true,
    },
    onTabletUp: {
      type: Boolean,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...kitchenDrawerComputed,
    ...mealsComputed,
    ...recipesComputed,
    currentView() {
      return this.navContent[this.activeNavIndex];
    },
    currentPrimaryView() {
      return this.primaryNavContent[this.activePrimaryNavIndex];
    },
    meal() {
      return this.data;
    },
  },
  mounted() {},
  methods: {
    ...kitchenDrawerMethods,
    ...mealsMethods,
    ...recipesMethods,
    ...dishesMethods,
    ...planMethods,
    ...primaryNavMethods,
    ...groceryListMethods,
    addMeal() {
      this.setDishToAdd({ mealId: this.meal.id, recipeId: null });

      if (this.currentPrimaryView.primary && this.currentPrimaryView.component === 'Recipes') {
        this.resetPrimaryStack();
        this.toggleDrawer();
      } else {
        this.keepNavStateButToggleDrawer();
      }
    },
    async removeMeal() {
      const result = await this.removeDish(this.meal.dishId);
      if (result) {
        this.data.onRemove(this.meal.dishId);
        this.getCurrentPlanGrid().finally(() => {
          if (this.onTabletUp === undefined || this.onTabletUp) {
            return this.getGroceryList();
          }
        });

        this.onTabletUp ? this.navigateHigher() : this.toggleDrawer();
      }
    },
    async showDishDetails(recipe) {
      if (this.data.isPlanned) {
        this.navigateDeeper({
          title: this.$t('lblRecipe'),
          component: 'RecipeDetail',
          data: {
            ...recipe,
            dishId: this.data.dishId,
            isPlanned: this.data.isPlanned,
            onRevision: this.data.onRevision,
            parentMealId: this.meal.id,
          },
        });
      } else {
        this.navigateDeeper({
          title: this.$t('lblRecipe'),
          component: 'RecipeDetail',
          data: recipe,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'theme.scss';

.meal-detail {
  @extend %scrollable-drawer-content;

  background-color: $color-plan-detail-bg;

  .detail-content-container {
    padding: 0 1.6rem 10rem;

    .section-title {
      margin: 2rem 0 1rem;
    }
  }

  .remove-link {
    color: $color-action;
    font-size: 1.5rem;
    font-weight: bold;
    margin: 2rem 0;
    text-align: center;

    &:hover {
      cursor: pointer;
    }
  }

  &.screen-lg {
    border-bottom-left-radius: 2.5rem;
    border-bottom-right-radius: 2.5rem;

    .detail-content-container {
      padding-bottom: 0;
    }

    &.drawerModal {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
      height: 100%;
    }
  }
}
</style>
